import Api from "./Api"
import { AgmodalStore, RolesStore, routerStore } from "./CommonState"
import { RoleType } from "./Types"

const ROLEAPI = {
    CREATE: `${process.env.REACT_APP_API_SERVER}/api/v1/roles/new`,
    DELETE: (id) => `${process.env.REACT_APP_API_SERVER}/api/v1/roles/delete/${id}`,
}

export default class RolesApi {
    static async apiCreateRole(setloading, role) {
        console.log("Inside to apiCreateRole")
        try {
           Api.post(ROLEAPI.CREATE, role, (data) => {
                console.log(data)
                if(data) {
                    setloading(false)
                    AgmodalStore.pageVisible = false
                    AgmodalStore.apiCall = true
                    routerStore.rolesCurrentView = "list"
                    RolesStore.RolesRec.set(new RoleType())
                }
           }, setloading)
        } catch (e) {
            console.log(`apiCreateRole: ${e}`)
        }
    }

    static async apiDeleteRoleByID(setLoading, role, callback) {
      try {
        Api.post(ROLEAPI.DELETE(role._id),role, (data) => {
        // Api.post(ROLEAPI.CREATE, role, (data) => {
          console.log(data)
          if (data) {
            AgmodalStore.pageVisible = false
            AgmodalStore.apiCall = true
            routerStore.rolesCurrentView = "list"
            RolesStore.RolesRec.set(new RoleType())
            if (callback) callback()
          }
        }, setLoading)
      } catch (e) {
        console.log(`apiDeleteRoleByID: ${e}`)
        if (callback) callback()
      }
    }
}
